/*
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2022-08-29 09:06:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-18 16:32:12
 * @FilePath: \dzCloud\src\plugins\mixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import { baseType } from '@tiktok/config/index';
Vue.mixin({
    methods: {
        // 埋点
        setHmt(txt) {
            if (txt.indexOf('_') > -1) {
                window._dzPoint && window._dzPoint.push(['_trackEvent', txt.split('_')[0], txt.split('_')[1]]);
            }
        },
        _hm88Point(val = {}) {
            let url = this.$isDev
                ? 'https://dkd-test.dazeyun.com/distribution'
                : 'https://api.fjdaze.com/dkddistr/distribution';

            this.$ajax.post(url + `/report/action/reporting`, val, { headers: { identyFrom: 2 } }).then(() => {
                //
            });
        },
        // 续费
        toBuy() {
            if (baseType !== 'PUTI') {
                window.open('https://fuwu.jinritemai.com/detail?service_id=97&from=isv.detail');
            } else {
                window.open(
                    'https://fuwu.jinritemai.com/detail?btm_ppre=a0254.b7465.c6844&btm_pre=a0254.b9825.c7579.d6976_2&from=isv.detail&page_from=1gvl0tv0n_b9825&pre_show_id=fc99f1ab-cdd3-4eee-b707-c41f57ddf4d6&service_id=25314'
                );
            }
        },
        //去好评
        toEvaluate() {
            window.open(
                'https://fuwu.jinritemai.com/evaluationManage?btm_pre=a0254.b9015.c0.d0&btm_ppre=a0254.b3624.c8047.d7528&page_from=1g2ocl4i1_b9015&pre_show_id=4b52b867-e6c3-41fd-818c-f963a01b3723'
            );
        },
        //超出提示

        exceedingPrompt(userInfos) {
            const userInfo = JSON.parse(localStorage.getItem('dzhmUserinfo'));
            // versionNo 试用版 标准版 高级版 豪华版
            // const totalCopyCount = userInfos.dayCopyNumber - userInfos.todayCopyCount; // 今日可用
            // const monthCopyCount = userInfos.monthCopyNumber - userInfos.monthCopyCount; // 本月可用

            if (userInfo.versionNo === '试用版' || userInfo.versionNo === '标准版' || userInfo.versionNo === '高级版') {
                this.$refs.exceeding.open(userInfos);
                // this.$confirm(
                //     <div>
                //         <div class="fz14 mb20">
                //             {userInfo.versionNo === '试用版'
                //                 ? '帮助您快速上货至抖音店铺，一键复制，全店搬家，支持多个货源平台！'
                //                 : '你的复制数使用已超出，为确保不影响正常使用，请您立即升级版本'}
                //         </div>
                //         <div>
                //             <img src="https://oss.fjdaze.com/oneKeyCopy1688/dy/copy/dy-edition.png" />
                //         </div>
                //         <div class="mt10 mb10 dz-flex-between dz-aic pl20 pr20 b-fffbeb c-ff5 h50">
                //             <p>
                //                 {userInfo.versionNo === '试用版'
                //                     ? '高级版支持复制主图视频 / 货源库存同步 / 违禁词检测 / 全店预售！'
                //                     : '一键上货、全店搬家、支持30+家平台'}
                //             </p>
                //         </div>
                //     </div>,
                //     userInfo.versionNo === '试用版'
                //         ? '您免费版条数已使用完，请及时升级续费'
                //         : '今日续订再送您200条复制数',
                //     {
                //         dangerouslyUseHTMLString: true,
                //         distinguishCancelAndClose: true,

                //         confirmButtonText: '限时八折升级',
                //         cancelButtonText: '增值订购',
                //         customClass: 'w710',
                //         callback: (e) => {
                //             if (e == 'confirm') {
                //                 window.open(
                //                     'https://fuwu.jinritemai.com/detail?service_id=97&searchKey=&btm_pre=a0254.b9825.c7579.d6976_11&btm_ppre=a0254.b3624.c0.d0&page_from=1gjg2er05_b9825&pre_show_id=02379f09-925c-4747-9c33-813b235e9538',
                //                     '_blank'
                //                 );
                //             } else if (e === 'cancel') {
                //                 this.$router.push({
                //                     path: '/vip/order',
                //                 });
                //             } else if (e === 'close') {
                //                 return false;
                //             }
                //         },
                //     }
                // );
            } else {
                this.$message.warning('您的复制数已超出，请您明天继续复制!');
            }
        },
        //版本功能划分
        versionDivision(type) {
            const userInfo = JSON.parse(localStorage.getItem('dzhmUserinfo'));
            // versionNo 试用版 标准版 高级版 豪华版
            //标准版及以上版本使用 当为试用版时standard区分两个判断
            if (type == 'standard' && userInfo.versionNo === '试用版') {
                //试用版
                return true;
            } else if (
                (userInfo.versionNo === '试用版' && type !== 'standard') ||
                (userInfo.versionNo === '标准版' && type !== 'standard')
            ) {
                // 该功能仅限高级版及豪华版用户使用;
                return true;
            } else {
                return false;
            }
        },
        //复制到更多平台
        getOpenPlatform(item) {
            if (item.text === '拼多多·大泽上货') {
                this.setHmt('复制页_引流拼多多');
            } else if (item === '快手·大泽上货') {
                this.setHmt('复制页_引流快手');
            } else {
                this.setHmt('复制页_引流视频号');
            }
            window.open(item.openUrl, '_blank');
        },
    },
});
